import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Redirects URLs with trailing slashes to their non-trailing versions.
 * Preserves search params and hash.
 *
 * Must be placed inside BrowserRouter but outside Routes.
 *
 * @example
 * /guides/foo/ -> /guides/foo
 * /tools/dora-calculator/?a=1 -> /tools/dora-calculator?a=1
 * / -> / (root is unchanged)
 */
export default function TrailingSlashRedirect() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname !== '/' && pathname.endsWith('/')) {
      navigate(`${pathname.slice(0, -1)}${search}${hash}`, { replace: true });
    }
  }, [pathname, search, hash, navigate]);

  return null;
}
